import { calendlyTypeApi } from '@src/features/settings/pages/integration/services/get-calendly-types';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import type { ChipValueRendererProps } from './chip-member-value';

export const ChipLeadCalendlyTypeValue = ({ id }: ChipValueRendererProps) => {
  const isValueStr = isNaN(+id);

  const { data: calendlyType } = calendlyTypeApi.useFetchOne(
    { id },
    { enabled: !!id && !isValueStr }
  );

  return formatTextForDisplay(isValueStr ? String(id) : calendlyType!.name);
};
